import { Route } from 'react-router-dom'
import SettingsPage from './pages/SettingsPage'
import ShieldPage from './pages/Shield/page'

const routes = [
	<Route path={'/settings'} element={<SettingsPage />} key='settings' />,
	<Route path={'/settings/shield/:raffle_id'} element={<ShieldPage />} key='shield' />,
]

export default routes
